import React from 'react';
import PropTypes from 'prop-types';
import { SidePanel } from 'front-onceforall-core';
import SettingsView from '../../../../../views/settings/SettingsView';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const UserSettingsView = props => {
  let triggerCloseUserSettingsPanel = () => {};
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.isUserPanelOpen && /*#__PURE__*/_jsx(SidePanel, {
      setCloseTrigger: closeFunction => {
        triggerCloseUserSettingsPanel = closeFunction;
      },
      big: true,
      onClose: props.onClose,
      children: /*#__PURE__*/_jsx(SettingsView, {
        onCancel: () => triggerCloseUserSettingsPanel()
      })
    })
  });
};
UserSettingsView.propTypes = {
  isUserPanelOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
export default UserSettingsView;